import { Text, StyleSheet, Platform, Alert, Modal, View, TouchableOpacity } from 'react-native';
import {
  ColorTokens,
  ColorTokensMap,
  FontFamilyTokens,
  FontSizeTokens,
  SizeTypeTokens,
  TextAlignTokens,
  TypographyTypeDLS,
} from '@voltmoney/schema';
import React, { useState } from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';

import classes from '../../styles/globalClasses';
import { PrivateStackParamList } from '../../navigationApp/types';
import { themeColorSet, ThemedPressable, ThemedView } from '../../theme';
import Svg from '@sharedComponents/SvgImage/Svg';
import { BASE_IMAGE_URL } from '../../configs/constants';
import Typography from '@sharedComponents/typography/Typography';
import ThemeProvider from '@voltmoney/theme';
import LogoutIcon from '../../../assets/Icons/LogoutIcon';
import Question from '../../../assets/Icons/QuestionIcon';
import ContactIcon from '../../../assets/Icons/ContactIcon';
import InfoIcon from '../../../assets/Icons/InfoIcon';
import { CaretRight, X } from '@app/sharedComponents/Icons/index';
import LogOutUser from '@app/helper/logout';
import {useAppSelector} from '@app/store/hooks'
import { ThemedText, ThemedTouchableOpacity } from '@app/theme/Components';
import {getVersion} from 'react-native-device-info'
import TypographyBase from '@app/sharedComponents/typography/Typography.base';
import ScreenWrapper from '@app/hoc/ScreenWrapper';
import { Space } from '@voltmoney/component';
import { checkColor, useDarkMode } from '@app/utils';

type ScreenProps = NativeStackScreenProps<
  PrivateStackParamList,
  'USER_PROFILE'
>;

type MENU_ITEMS_TYPE = {
  id: number;
  label: string;
  navigateTo: keyof PrivateStackParamList;
  icon: React.ReactNode;
}[];

const MENU_ITEMS: MENU_ITEMS_TYPE = [
  {
    id: 1,
    label: 'FAQs',
    navigateTo: 'FAQ',
    icon: <Question size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 2,
    label: 'Contact us',
    navigateTo: 'CONTACT_US',
    icon: <ContactIcon size={24} color={checkColor("#1434CB")}/>,
  },
  {
    id: 3,
    label: 'About us',
    navigateTo: 'ABOUT_US',
    icon: <InfoIcon size={24} fill={checkColor("#1434CB")}/>,
  },
];


const _renderLogoutConfirmationModal = (
    modalVisible: boolean,
    setModalVisible: Function,
  ) => (
    <Modal
      animationType={'fade'}
      transparent={true}
      visible={modalVisible}
      onRequestClose={() => {}}>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          backgroundColor: '#1D293966',
        }}>
        <View
          style={{
            backgroundColor: 'white',
            width: '70%',
            maxWidth: 508,
            height: '20%',
            borderRadius: 10,
            justifyContent: 'center',
            alignItems: 'center',
            borderColor: 'black',
            borderWidth: 2,
            padding: 10,
          }}>
          <Typography
            label="Are you sure you want to logout?"
            color={ColorTokens.Grey_Charcoal}
            fontSize={FontSizeTokens.SM}
            fontFamily={FontFamilyTokens.Poppins}
            fontWeight="400"
            lineHeight={24}
            textAlign={TextAlignTokens.center}
          />
          <Space.Component size={SizeTypeTokens.MD} />
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              width: '100%',
              height: 35,
              alignItems: 'center',
            }}>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                width: '100%',
              }}>
              <View
                style={{
                  width: 40,
                  height: 35,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <TouchableOpacity onPress={LogOutUser}>
                  <Typography
                    label="Yes"
                    color={ColorTokens.Primary_100}
                    fontSize={FontSizeTokens.SM}
                    fontWeight="400"
                    lineHeight={18}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: 40,
                  height: 35,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <TouchableOpacity onPress={() => setModalVisible(false)}>
                  <Typography
                    label="No"
                    color={ColorTokens.Primary_100}
                    fontSize={FontSizeTokens.SM}
                    fontWeight="400"
                    lineHeight={18}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );

const handleMobileLogout = () =>
  Alert.alert('', 'Are you sure you want to Logout?', [
    {
      text: 'Cancel',
      style: 'cancel',
    },
    {text: 'OK', onPress: LogOutUser},
  ]);

const UserProfile = ({ navigation , route }: ScreenProps) => {
  const {showLogout} = useAppSelector(state => state.platformParams);
  const theme = ThemeProvider.getTheme();
  const colorMapping: ColorTokensMap = theme.colors;
  const userDetails = useAppSelector(state => state.auth.userDetails);
  const [modalVisible , setModalVisible] = useState(false)
  const isDarkMode = useDarkMode();

  return (

  <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true}} >
    <ThemedView backgroundColor="bg-surface-primary" flex={1}>
      <ThemedView
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingVertical="md"
        paddingHorizontal="lg"
        borderBottomWidth={1}
        style={[
          {
            borderBottomColor: '#f1f3f5',
          },
        ]}>
        <ThemedView flexDirection="row" alignItems="center">
          <ThemedView mr='sm'>
            <Svg
              height={40}
              width={40}
              url={BASE_IMAGE_URL + 'profile_pre1.png'}
            />
          </ThemedView>
          <Text
            style={[
              classes.b0b,
              {
                color:
                  colorMapping[
                    isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
                  ],
              },
            ]}>
            {userDetails?.user?.fullName ??
              `+91 ${userDetails.user?.phoneNumber.split('+91')[1]}`}
          </Text>
        </ThemedView>
        <ThemedTouchableOpacity
          hitSlop={{ left: 10, right: 10, bottom: 10, top: 10 }}
          mr="xs" onPress={() => navigation.goBack()}>
          <X size={18} />
        </ThemedTouchableOpacity>
      </ThemedView>
      <ThemedView mt="md">
        {MENU_ITEMS.map(item => {
          return (
            <ThemedPressable
              onPress={() => navigation.navigate(item?.navigateTo)}
              paddingHorizontal="lg"
              key={item.id}>
              <ThemedView
                mr="xs"
                style={[
                  {
                    borderBottomColor: '#f1f3f5',
                  },
                ]}
                borderBottomWidth={1}
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                paddingVertical="md">
                <ThemedView flexDirection="row" alignItems="center">
                  <ThemedView
                    mr='md'
                    height={40}
                    width={40}
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="bg-surface-page"
                    borderRadius="full">
                    {item?.icon}
                  </ThemedView>
                  <ThemedText color="text-primary" variant="b3m">
                    {item?.label}
                  </ThemedText>
                </ThemedView>
                <CaretRight color={themeColorSet['icon-primary']} />
              </ThemedView>
            </ThemedPressable>
          );
        })}
      </ThemedView>
      {
        showLogout && 
      <ThemedPressable
        onPress={() => {
          if(Platform.OS === 'web') {
            setModalVisible(true)
          }
          else {
            handleMobileLogout()
          }
        }}
        paddingHorizontal="lg"
        paddingVertical="sm"
        borderTopWidth={1}
        borderColor='border-secondary'
        position="absolute"
        width={'100%'}
        bottom={20}>
          <ThemedView
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center">
          <ThemedTouchableOpacity
          hitSlop={{left : 20 , right : 20 , top : 20 , bottom : 20}}
          eventName='LOGOUT_BUTTON'
          onPress={() => {
           if(Platform.OS === 'web') {
             setModalVisible(true)
           }
           else {
             handleMobileLogout()
           }
         }}
          flexDirection="row" alignItems="center">
            <ThemedView
              mr='md'
              height={40}
              width={40}
              alignItems="center"
              justifyContent="center"
              backgroundColor="bg-surface-page"
              borderRadius="full">
              <LogoutIcon color={checkColor("#1434CB")}/>
            </ThemedView>
            <Typography
              fontFamily={FontFamilyTokens.Inter}
              fontSize={FontSizeTokens.SM}
              fontWeight={'600'}
              lineHeight={20}
              label={'Logout'}
              color={
                isDarkMode ? ColorTokens.White_20 : ColorTokens.Primary_100
              }
            />
          </ThemedTouchableOpacity>
        {Platform.OS !== 'web' && (
          <ThemedView>
            <TypographyBase color={ColorTokens.Grey_Smoke} fontSize={FontSizeTokens.XS} typeDLS={TypographyTypeDLS.B3R} label={'App version ' + getVersion()} />
          </ThemedView>
        )}
        </ThemedView>
      </ThemedPressable>
      }
    </ThemedView>
    {_renderLogoutConfirmationModal(modalVisible, setModalVisible)}
  </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5FCFF',
  },
  text: {
    fontSize: 20,
    textAlign: 'center',
    margin: 10,
  },
});

export default UserProfile;
